module.exports = __webpack_public_path__ + "static/media/menu-close.060a1c69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/menu-close.svg
// module id = 77
// module chunks = 0